module.exports = __webpack_public_path__ + "static/overall-fa02816ad8bef00eeadbb251b3de158e.png";